import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2),
    [theme.breakpoints.only('xs')]: {
      width: '100%',
    },
    [theme.breakpoints.only('sm')]: {
      width: '60%',
    },
    [theme.breakpoints.up('md')]: {
      width: '40%',
    }
  },
  recurrenceTypeSelector: {
    [theme.breakpoints.up('sm')]: {
      width: '50%',
    },
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    }
  },
  repeatUntil: {
    [theme.breakpoints.up('sm')]: {
      width: '50%',
    },
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    }
  },
  overlay: (props) => ({
    position: 'absolute',
    display: props.display,
    width: '100%',
    height: '100%',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: '#ADADAD95',
    zIndex: 2,
    cursor: 'pointer',
    borderRadius: '4px'
  }),
  overlayContent: {
    position: 'absolute',
    top: '22%',
    left: '45%'
  }
}));